export default "/assets/images/mila-room-showcase-sm-01.jpg?f31024b4ca8a0d88650429bde436a2a7";